import { LMFDataEntryPage } from "./DataEntryPage";
import {
  LMFDataEntryProvider,
  useDataEntryContext,
} from "./context/reducer.provider";
import { TimerProvider } from "./context/timer.provider";

import { themeMESF } from "@dexteel/mesf-core";
import { ThemeProvider } from "@mui/material/styles";

type Props = {};
const LMFDataEntry = (props: Props) => {
  return (
    <LMFDataEntryProvider>
      <TimerProviderWrapper />
    </LMFDataEntryProvider>
  );
};

const TimerProviderWrapper = () => {
  const { state } = useDataEntryContext();
  return (
    <TimerProvider isOldProcess={!!state.deProcess?.process.IsOldProcess}>
      <div id={"dummy"} style={{ height: "0", width: "0" }}></div>
      <ThemeProvider theme={themeMESF}>
        <LMFDataEntryPage />
      </ThemeProvider>
    </TimerProvider>
  );
};
export default LMFDataEntry;
